;(function (window, APP, Backbone, Marionette, $, _) {
	'use strict';
	var Model = APP.module('Model');

	Model.StaticContent = Backbone.Model.extend({
		initialize: function( attrs ){
			var url_parts = CONFIG.STATIC_URL.split('/'),
				start_part = url_parts[url_parts.length - 1];

			this.filename_part = attrs.filename_part;
			this.property      = start_part + this.filename_part;
		},
		appendScript: function ( _this ) {
			var static_script = document.createElement('script'),
				url           = CONFIG.STATIC_URL + this.filename_part + '.js?_t=' + new Date().getTime();

			static_script.src = url;
			static_script.onload = function() {
				_this.showContent();
			};

			if ( $("script[src*='" + url + "']").length == 0 ) {
				document.body.appendChild( static_script );
			}
			else {
				setTimeout(function () {
					_this.showContent();
				}, 0);
			}

			return {
				script: static_script,
				url: url
			};
		},
		getFaqsList: function(items, type) {
			var cat = items.categories,
				faqs = items.items,
				i = 0, j = 0, k = 0,
				categories, categoryManager,
				createCategoryNodeList,
				createSubCategoryNodeList,
				appendFaqItem, topLvlCategories,
				defaultCategory, isNotEmpty, itemTemplate;

			categoryManager = function(){
				var cat_template,
					template = {},
					sub_cat_template = [{
						name: 'Uncategorized',
						id: -1,
						type: type,
						items: []
					}];

				cat_template = sub_cat_template.slice();
				cat_template[0].subcategory = [];

				return {
					create: function(type){
						if(type === 'top'){
							template = cat_template.slice();
						}
						else if(type === 'sub'){
							template = sub_cat_template.slice();
						}

						return this;
					},
					set: function(field, value){
						template[0][field] = value;
						return this;
					},
					get: function(){
						return template[0];
					},
					getAsArray: function(){
						return template;
					}
				};
			};

			createCategoryNodeList = function (category) {
				if (type && type == category.type && category.parent_id === 0){
					return categoryManager().create('top')
						.set('id', category.id)
						.set('name', category.name)
						.set('type', category.type).get();
				}
			};

			createSubCategoryNodeList = function (category) {
				cat.map(function (cat){
					if (category.id == cat.parent_id && category.type == cat.type){
						var subCat = categoryManager().create('sub')
							.set('id', cat.id)
							.set('name', cat.name)
							.set('type', category.id).get();

						category.subcategory.push(subCat);
					}
				});
			};

			isNotEmpty = function(a){
				return !!a;
			};

			defaultCategory = categoryManager().create('top').getAsArray();
			topLvlCategories = cat.map(createCategoryNodeList).filter(isNotEmpty);
			categories = defaultCategory.concat(topLvlCategories);
			categories.map(createSubCategoryNodeList);

			appendFaqItem = function(category) {
				faqs.map(function(faq) {
					if (category.type == faq.type){
						if (category.id == faq.category_id || (category.id == -1 && faq.category_id === 0)){
							category.items.push(itemTemplate(faq));
						}
						if (category.subcategory){
							category.subcategory.map(function(subCat){
								if (subCat.id == faq.category_id){
									subCat.items.push(itemTemplate(faq));
								}
							});
						}
					}
				});
			};

			itemTemplate = function(faq) {
				return {
					title: faq.title,
					text: faq.text,
					tags: faq.tags.split(','),
					type: faq.type,
					id: faq.id
				};
			};

			categories.map(appendFaqItem);

			return categories;
		}
	});

}(window, APP, Backbone, Marionette, $, _));